import React, { useState } from "react";
import { Modal, ModalBody } from "reactstrap";
import axios from "../../../axios-instance";
import { getAdminBusinessId } from "../../../utils/authHelper";
import { notification } from "../../../utils/utility";

const MAX_TOTAL = 6;

/**
 * Request additional calendar slots for a staff member (super-admin must approve).
 */
const RequestStaffCalendarModal = ({ staff, onSubmitted }) => {
  const [open, setOpen] = useState(false);
  const [quantity, setQuantity] = useState(1);
  const [reason, setReason] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const allowance = Number(staff?.staff_calendar_allowance || 1);
  const remaining = Math.max(0, MAX_TOTAL - allowance);
  const maxQty = Math.min(5, remaining);

  const toggle = () => {
    if (!open) {
      setQuantity(1);
      setReason("");
    }
    setOpen(!open);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    if (!reason.trim() || reason.trim().length < 3) {
      return notification.error("Please enter a reason (at least 3 characters).");
    }
    if (quantity < 1 || quantity > maxQty) {
      return notification.error(`You can request between 1 and ${maxQty} additional calendar(s).`);
    }

    setSubmitting(true);
    axios
      .post("/admin/staff-calendar-requests", {
        staff_id: staff.id,
        quantity: Number(quantity),
        reason: reason.trim(),
        business_id: getAdminBusinessId(),
      })
      .then((res) => {
        notification.success(res?.data?.message || "Calendar request submitted.");
        setOpen(false);
        if (onSubmitted) {
          onSubmitted(res?.data?.data?.entity || res?.data?.entity);
        }
      })
      .catch((err) => {
        const msg =
          err?.response?.data?.message ||
          err?.response?.data?.error ||
          "Could not submit calendar request.";
        notification.error(msg);
      })
      .finally(() => setSubmitting(false));
  };

  if (remaining < 1) {
    return null;
  }

  const pending = staff?.calendar_request?.status === "pending";

  return (
    <>
      <button
        type="button"
        className="btn btn-sm btn-outline-primary ml-2"
        title={pending ? "A request is already pending" : "Request more calendars"}
        disabled={pending}
        onClick={toggle}
        style={{ minWidth: 32, fontWeight: 700 }}
      >
        +
      </button>

      <Modal isOpen={open} toggle={toggle} centered>
        <ModalBody>
          <div className="rd_modalvieew">
            <div className="box_content rd_modalboxcontent">
              <div className="rd_inputselectheadermodalsetting">
                <button className="rd_colsebtn" onClick={toggle} type="button" />
              </div>
              <h5 className="rd_modalheadertext">Request more calendars</h5>
              <p className="rd_modalheadertextparath mt-2 mb-3">
                Request additional calendar connections for{" "}
                <strong>
                  {staff.first_name} {staff.last_name}
                </strong>
                . They currently have {allowance} of {MAX_TOTAL} allowed.
              </p>
              <form onSubmit={onSubmit}>
                <div className="form-group mb-3">
                  <label className="form-label">Number of additional calendars</label>
                  <select
                    className="form-control"
                    value={quantity}
                    onChange={(e) => setQuantity(Number(e.target.value))}
                  >
                    {Array.from({ length: maxQty }, (_, i) => i + 1).map((n) => (
                      <option key={n} value={n}>
                        {n}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form-group mb-4">
                  <label className="form-label">Reason</label>
                  <textarea
                    className="form-control"
                    rows={4}
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                    placeholder="Why does this staff member need more calendars?"
                    required
                  />
                </div>
                <div className="rd_cancelappbtnmodal">
                  <button type="button" className="rd_cancel" onClick={toggle}>
                    Cancel
                  </button>
                  <button type="submit" className="btn btn-app" disabled={submitting}>
                    {submitting ? "Sending…" : "Submit request"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default RequestStaffCalendarModal;
